$(document).ready(function () {
    if (!$('#audit-trail-table').length) {
        return;
    }

    let skip = 0;
    const take = 25;
    let loading = false;

    let display_date_format = $('meta[name="date-format"]').attr('content');

    $('.audit-trail-datepicker').flatpickr({
        weekNumbers: true,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: display_date_format,
        closeOnSelect: true,
        allowInput: true,
        onReady: function (dateObj, dateStr, instance) {
            let $cal = $(instance.calendarContainer);
            if ($cal.find('.flatpickr-clear').length < 1) {
                $cal.append('<div class="flatpickr-clear">Clear</div>');
                $cal.find('.flatpickr-clear').on('click', function () {
                    instance.clear();
                    instance.close();
                });
            }
        }
    });

    function getFilters() {
        return {
            table_id: $('#audit-trail-table').val(),
            date_from: $('#audit-trail-date-from').val(),
            date_to: $('#audit-trail-date-to').val(),
            user_id: $('#audit-trail-user').val(),
            action: $('#audit-trail-action').val(),
            source: $('#audit-trail-source').val(),
            field: $('#audit-trail-field').val()
        };
    }

    function loadRows(reset) {
        let filters = getFilters();

        if (!filters.table_id) {
            return;
        }

        if (reset) {
            skip = 0;
            $('#audit-trail-rows').empty();
            $('#audit-trail-empty').addClass('d-none');
            $('#audit-trail-prompt').addClass('d-none');
        }

        if (loading) {
            return;
        }
        loading = true;

        $.ajax({
            type: 'GET',
            url: '/audit-trail/records',
            data: $.extend({}, filters, {take: take, skip: skip}),
            success: function (html, status, xhr) {
                let hasMore = xhr.getResponseHeader('X-Has-More') === '1';

                $('#audit-trail-rows').append(html);
                skip = $('#audit-trail-rows').children('tr[data-log-id]').length;

                if (!skip) {
                    $('#audit-trail-empty').removeClass('d-none');
                }

                $('#audit-trail-load-more-wrap').toggleClass('d-none', !hasMore);
                loading = false;
            },
            error: function () {
                loading = false;
            }
        });
    }

    $('#audit-trail-table').on('change', function () {
        loadRows(true);
    });

    $('#audit-trail-filter').on('click', function (e) {
        e.preventDefault();
        loadRows(true);
    });

    $('#audit-trail-load-more').on('click', function (e) {
        e.preventDefault();
        loadRows(false);
    });

    $('#audit-trail-export').on('click', function (e) {
        e.preventDefault();
        let filters = getFilters();

        if (!filters.table_id) {
            return;
        }

        window.location = '/audit-trail/export?' + $.param(filters);
    });

    $(document).on('click', '.show-audit-trail-changes', function (e) {
        e.preventDefault();
        let $toggle = $(this),
            logId = $toggle.data('log-id'),
            $row = $('.audit-trail-changes-row[data-log-id="' + logId + '"]'),
            $cell = $row.find('td');

        if ($row.hasClass('d-none')) {
            if (!$row.hasClass('loaded')) {
                $.ajax({
                    type: 'GET',
                    url: '/audit-trail/records/' + logId + '/changes',
                    success: function (html) {
                        $cell.html(html);
                        $row.addClass('loaded').removeClass('d-none');
                    }
                });
            } else {
                $row.removeClass('d-none');
            }
            $toggle.addClass('expanded');
        } else {
            $row.addClass('d-none');
            $toggle.removeClass('expanded');
        }
    });
});
